import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { requests } from "../../../common/RestAPI";
import { PAGE_URL, PLATFORM_URL } from "../../../value/Url";
import ContentsProps from "../../../interfaceTypes/ContentsProps";
import ProjectMgmt from "./NodeMgmt";
import {  NodeData, tableHeaders } from "./NodeData";
import { generateQueryParam, sleep } from "common/util";


export default function ProjectMgmtContainer(props:ContentsProps) {
    const { t } = useTranslation();
    const [infoText, setInfoText] = useState('');
    const [infoError, setInfoError] = useState(false);

    const fetchIdRef = useRef(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [totalItemCount, setTotalItemCount] = useState(0);
    const [tableData, setTableData] = useState<NodeData[]>([]);
    const [refreshYn, setRefreshYn] = useState(false);

    const headers = useMemo(() => tableHeaders, []);
    const navigate = useNavigate();

    useEffect(() => {
        AlertFunction('');
    }, []);

    function AlertFunction(text:string, error=false) {
        setInfoText(text);
        setInfoError(error);
    }


    function clickActionMenu(code) {
        if(code === "NODE_SYNC") {
            props.setLoading(true);
            requests.post(PLATFORM_URL.NODE + PLATFORM_URL.SYNC, {})
            .then(async (response) => {
                if (response.status === 200) {
                    AlertFunction(t("SYNC_COMPLETED_TEXT"));
                    setRefreshYn(true);
                }
            })
        }
    }

    function clickRow(item) {

    }

    function generateUiData(data) {
        return data.map((d)=>{
            d["cpu"] = {
                total_count : d.cpu_total_count,
                used_nano_cores : d.cpu_used_nano_cores,
                percent: d.cpu_total_count > 0 ? Math.ceil(100 * d.cpu_used_nano_cores / (d.cpu_total_count * 1000 * 1000 * 1000)) : 0
            }
            d["memory"] = {
                total_count : d.memory_total_capacity_mb,
                used_count : d.memory_used_capacity_mb,
                percent: d.memory_total_capacity_mb > 0 ? Math.ceil(100 * d.memory_used_capacity_mb / d.memory_total_capacity_mb) : 0
            }
            d["storage"] = {
                total_count : d.storage_total_capacity_gb,
                used_count : d.storage_used_capacity_gb,
                percent: d.storage_total_capacity_gb > 0 ? Math.ceil(100 * d.storage_used_capacity_gb / d.storage_total_capacity_gb) : 0
            }
            return d
        })
    }


    function executeLoadLodList(pageSize, pageIndex, sortByName, sortByDescYn, categoryType, categoryCode, search, showLoading) {
        if(showLoading) {
            setCurrentPage(pageIndex);
            props.setLoading(true);
        }

        requests.get(PLATFORM_URL.NODE, generateQueryParam(pageSize, pageIndex, sortByName, sortByDescYn, categoryType, categoryCode, search))
        .then((response) => {
            if (response.status === 200 && response.data?.items && pageIndex === response.data.page-1) {
                setTableData(generateUiData(response.data.items));
                setPageCount(response.data.pages);
                setTotalItemCount(response.data.total);
            }
            if(showLoading) {
                props.setLoading(false);
                setRefreshYn(false);
            }
        })
        .catch((error) => {
            AlertFunction(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"), true);
            if(showLoading) {
                props.setLoading(false);
                setRefreshYn(false);
            }
        })
    }



    const fetchData = useCallback(({ pageSize, pageIndex, sortByName, sortByDescYn, categoryType, categoryCode, search, showLoading }) => {
        const fetchId = ++fetchIdRef.current
        if(fetchId === fetchIdRef.current) {
            executeLoadLodList(pageSize, pageIndex, sortByName, sortByDescYn, categoryType, categoryCode, search, showLoading);
        }
    }, []);


    return (
        <ProjectMgmt
            clickActionMenu={clickActionMenu}
            clickRow={clickRow}
            fetchData={fetchData}
            currentPage={currentPage}
            pageCount={pageCount}
            headers={headers}
            tableData={tableData}
            totalItemCount={totalItemCount}
            refreshYn={refreshYn}
            infoText={infoText}
            infoError={infoError}
        />
    )
}